// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminHeader-adminHeaderContainer-v6rzJ {
  position: fixed;
  left: var(--sideMenu-width);
  right: 0;
  background-color: var(--background-primary);
  z-index: 1030;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  border-bottom: 1px solid var(--primary-border);
  padding: 24px;
  height: var(--sideMenu-header-height);
}

.AdminHeader-adminHeaderMenuIcon-u9QCi {
  display: none;
}

.AdminHeader-hamburger-LNluu .AdminHeader-iconBar-Qz7_I {
  display: block;
  width: 100%;
  height: 3px;
  background: var(--primary-foreground);
  -webkit-transition: .3s;
  transition: .3s;
}

.AdminHeader-hamburger-LNluu .AdminHeader-iconBar-Qz7_I+.AdminHeader-iconBar-Qz7_I {
  margin-top: 4px;
}

.AdminHeader-hamburger-LNluu {
  width: 25px;
}

.AdminHeader-adminHeaderNavMenuContainer-7So7W {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  gap: 24px;
  grid-gap: 24px;
}

.AdminHeader-adminHeaderMenuItem-loX9v,
.AdminHeader-adminHeaderMenuItem-loX9v:hover,
.AdminHeader-adminHeaderMenuItem-loX9v:focus,
.AdminHeader-adminHeaderMenuItem-loX9v:active,
.AdminHeader-adminHeaderMenuItem-loX9v:active:hover,
.AdminHeader-adminHeaderMenuItem-loX9v:active:focus {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  padding: 0 !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 4px;
  grid-gap: 4px;
  color: var(--primary-foreground) !important;
  background-color: transparent !important;
  text-decoration: none;
  outline: unset;
  -webkit-box-shadow: unset;
          box-shadow: unset;
  border: unset;
  text-align: start;
  cursor: pointer;
}

.AdminHeader-adminHeaderMenuItemIcon-QQ4IK {
  width: 20px;
  height: 20px;
}

.AdminHeader-adminHeaderDropdownMenuInnerWrapper-YNY9o {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  gap: 8px;
  grid-gap: 8px;
}

.AdminHeader-adminHeaderDropdownMenuSelect-Y8FdD {
  color: var(--primary-link-foreground);
}

@media (max-width: 1199px) {
  .AdminHeader-adminHeaderContainer-v6rzJ {
    left: 0;
    right: 0;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
  }

  .AdminHeader-adminHeaderMenuIcon-u9QCi {
    display: inline-block;
    cursor: pointer;
  }
}

@media (max-width: 767px) {
  .AdminHeader-adminHeaderContainer-v6rzJ {
    padding: 24px 16px;
  }

  .AdminHeader-adminHeaderMenuItemText-HMnGT {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AdminHeader/AdminHeader.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2BAA2B;EAC3B,QAAQ;EACR,2CAA2C;EAC3C,aAAa;EACb,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,uBAAe;EAAf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;;;;;;EAME,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,+BAAwB;EAAxB,+BAAwB;EAAxB,wBAAwB;EACxB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,2CAA2C;EAC3C,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,uBAA2B;MAA3B,oBAA2B;UAA3B,2BAA2B;EAC3B,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,OAAO;IACP,QAAQ;IACR,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".adminHeaderContainer {\n  position: fixed;\n  left: var(--sideMenu-width);\n  right: 0;\n  background-color: var(--background-primary);\n  z-index: 1030;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  border-bottom: 1px solid var(--primary-border);\n  padding: 24px;\n  height: var(--sideMenu-header-height);\n}\n\n.adminHeaderMenuIcon {\n  display: none;\n}\n\n.hamburger .iconBar {\n  display: block;\n  width: 100%;\n  height: 3px;\n  background: var(--primary-foreground);\n  transition: .3s;\n}\n\n.hamburger .iconBar+.iconBar {\n  margin-top: 4px;\n}\n\n.hamburger {\n  width: 25px;\n}\n\n.adminHeaderNavMenuContainer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 24px;\n  grid-gap: 24px;\n}\n\n.adminHeaderMenuItem,\n.adminHeaderMenuItem:hover,\n.adminHeaderMenuItem:focus,\n.adminHeaderMenuItem:active,\n.adminHeaderMenuItem:active:hover,\n.adminHeaderMenuItem:active:focus {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 24px;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center;\n  gap: 4px;\n  grid-gap: 4px;\n  color: var(--primary-foreground) !important;\n  background-color: transparent !important;\n  text-decoration: none;\n  outline: unset;\n  box-shadow: unset;\n  border: unset;\n  text-align: start;\n  cursor: pointer;\n}\n\n.adminHeaderMenuItemIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.adminHeaderDropdownMenuInnerWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  grid-gap: 8px;\n}\n\n.adminHeaderDropdownMenuSelect {\n  color: var(--primary-link-foreground);\n}\n\n@media (max-width: 1199px) {\n  .adminHeaderContainer {\n    left: 0;\n    right: 0;\n    justify-content: space-between;\n  }\n\n  .adminHeaderMenuIcon {\n    display: inline-block;\n    cursor: pointer;\n  }\n}\n\n@media (max-width: 767px) {\n  .adminHeaderContainer {\n    padding: 24px 16px;\n  }\n\n  .adminHeaderMenuItemText {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"adminHeaderContainer": `AdminHeader-adminHeaderContainer-v6rzJ`,
	"adminHeaderMenuIcon": `AdminHeader-adminHeaderMenuIcon-u9QCi`,
	"hamburger": `AdminHeader-hamburger-LNluu`,
	"iconBar": `AdminHeader-iconBar-Qz7_I`,
	"adminHeaderNavMenuContainer": `AdminHeader-adminHeaderNavMenuContainer-7So7W`,
	"adminHeaderMenuItem": `AdminHeader-adminHeaderMenuItem-loX9v`,
	"adminHeaderMenuItemIcon": `AdminHeader-adminHeaderMenuItemIcon-QQ4IK`,
	"adminHeaderDropdownMenuInnerWrapper": `AdminHeader-adminHeaderDropdownMenuInnerWrapper-YNY9o`,
	"adminHeaderDropdownMenuSelect": `AdminHeader-adminHeaderDropdownMenuSelect-Y8FdD`,
	"adminHeaderMenuItemText": `AdminHeader-adminHeaderMenuItemText-HMnGT`
};
module.exports = ___CSS_LOADER_EXPORT___;
